import { hotList } from '@/mocks/gossip';

const stats = [
  { value: '24h', label: '实时滚动上新' },
  { value: '实时', label: '热门爆料更新' },
  { value: '7+', label: '吃瓜分类栏目' },
];

const ticker = [
  '今晚热搜瓜已就位，边吃边看更带劲',
  '《巷口烟火》口碑持续发酵',
  '深夜食堂翻车名场面正在疯传',
  '阿澈新歌治愈无数夜归人',
  '周末瓜田合集新鲜出炉',
];

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden">
      <div className="relative min-h-[520px] bg-primary-600 md:min-h-[600px]">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20abstract%20warm%20watermelon%20and%20citrus%20inspired%20pattern%20with%20soft%20round%20shapes%20vibrant%20tomato%20orange%20and%20gold%20tones%20flat%20illustration%20background%20with%20subtle%20seeds%20and%20bubbles%20playful%20cheerful%20appetizing%20energy%20clean%20composition&width=1600&height=900&seq=hero-chigua&orientation=landscape"
          alt="吃瓜cb边吃边看暖色瓜田抽象背景"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-700/70 via-primary-600/60 to-primary-800/80"></div>

        <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 pb-16 pt-28 text-center md:px-6 md:pt-32">
          <span className="float-in inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm font-medium text-white backdrop-blur-sm">
            <span className="relative flex h-2 w-2 items-center justify-center">
              <span className="h-2 w-2 animate-ping rounded-full bg-accent-400"></span>
              <span className="absolute h-1.5 w-1.5 rounded-full bg-accent-400"></span>
            </span>
            边吃边看真香现场 · 实时滚动更新
          </span>

          <h1 className="float-in mt-6 font-display text-4xl leading-tight text-white md:text-6xl">
            吃瓜cb，配饭下饭两不误
          </h1>
          <p className="float-in mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/90 md:text-lg">
            热门爆料实时更新，边吃边看更带劲。吃瓜cb就位，开动你的好奇心，
            <span className="font-semibold text-accent-300">最新瓜料一次看够</span>，每一口都配得上你的饭。
          </p>

          <div className="float-in mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#feed"
              className="whitespace-nowrap rounded-full bg-accent-500 px-7 py-3.5 text-base font-bold text-foreground-950 transition-transform hover:-translate-y-0.5 hover:bg-accent-400"
            >
              开始今日吃瓜<i className="ri-arrow-right-line ml-1"></i>
            </a>
            <a
              href="#submit"
              className="whitespace-nowrap rounded-full border border-white/40 bg-white/10 px-7 py-3.5 text-base font-semibold text-white backdrop-blur-sm transition-colors hover:bg-white/20"
            >
              我也来投一瓜
            </a>
          </div>

          <div className="float-in mt-10 flex flex-wrap items-center justify-center gap-6 md:gap-10">
            {stats.map((s) => (
              <div key={s.label} className="flex flex-col items-center">
                <span className="font-display text-2xl text-accent-300 md:text-3xl">{s.value}</span>
                <span className="mt-1 text-xs text-white/80 md:text-sm">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative bg-primary-800 py-2.5 text-white">
        <div className="marquee-mask overflow-hidden">
          <div className="animate-marquee flex w-max items-center whitespace-nowrap pr-10">
            {[...ticker, ...ticker].map((t, i) => (
              <span key={i} className="flex items-center gap-2 text-sm">
                <i className="ri-fire-line text-accent-400"></i>
                {t}
                <span className="mx-4 text-white/40">·</span>
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="sr-only">
        <a href="#hot">查看今日热度榜 {hotList[0].title}</a>
      </div>
    </section>
  );
}